import linq from 'linq'
import { snakeToCamel, camelToSnake } from '../utility/stringUtility'
import Form from 'vform'
import moment from 'moment'

const FILLABEL = [
    'id',
    'title',
    'content',
    'imgPath',
    'link',
    'linkText',
    'start',
    'end',
    'isShow',
    'isImportant',
]

export default class News {
    constructor(data = null) {
        this.originalData = data

        this.id = 0
        this.title = ''
        this.content = ''
        this.link = ''
        this.imgPath = ''
        this.linkText = ''
        this.start = ''
        this.end = ''
        this.createdAt = ''
        this.isShow = 0
        this.isImportant = 0

        this.form = new Form()

        if (data) {
            this.create()
        }
    }

    get _model() {
        return 'News'
    }

    get data() {
        return this.originalData
    }

    get roundContent() {
        if (this.content.length > 50) {
            return this.content.substring(0, 50) + '...'
        }
        return this.content.substring(0, 50)
    }

    get hasError() {
        return Object.keys(this.form.errors.errors).length
    }

    get errors() {
        return linq
            .from(this.form.errors.errors)
            .select((x) => {
                return arrayWrap(x.value)[0]
            })
            .toArray()
    }

    get inputStart() {
        return this.start
    }

    set inputStart(val) {
        this.start = moment(val).format('YYYY-MM-DD H:m:s')
    }

    get inputEnd() {
        return this.end
    }

    set inputEnd(val) {
        this.end = moment(val).format('YYYY-MM-DD H:m:s')
    }

    get nullIgnore() {
        return ['title', 'content', 'link', 'linkText']
    }

    create() {
        linq.from(this.data)
            .select((x) => {
                x.key = camelToSnake(x.key)
                return x
            })
            .where((x) => this.hasOwnProperty(snakeToCamel(x.key)))
            .select((x) => {
                const key = snakeToCamel(x.key)

                if (typeof this[key] === 'number') {
                    this[key] = Number(x.value)
                    return
                }

                this[key] = x.value
                return x
            })
            .toArray()
    }

    getPostable() {
        if (!this.isShow) {
            this.isShow = 0
        } else {
            this.isShow = 1
        }

        return linq
            .from(this)
            .where((x) => linq.from(FILLABEL).any((xs) => xs === x.key))
            .where(
                (x) =>
                    x.value ||
                    linq.from(this.nullIgnore).any((j) => j === x.key) ||
                    (typeof x.value === 'number' && x.key === 'isShow') ||
                    x.key === 'isImportant'
            )
            .select((x) => {
                return {
                    key: camelToSnake(x.key),
                    value: x.value,
                }
            })
            .toObject('$.key', '$.value')
    }

    fill() {
        this.form = new Form(this.getPostable())
    }

    async post(url) {
        this.fill()
        return await this.form.post(url)
    }

    async delete(url) {
        this.fill()
        return await this.form.delete(url)
    }

    async patch(url) {
        this.fill()
        return await this.form.patch(url)
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/models/News.js